import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { BUILDING_TYPE } from '@buildium/angularjs-core/dist/constants/properties';

const actions = {
    getOwnershipAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownershipaccounts/:id`
    },
    addOwnershipAccount: {
        method: 'POST',
        url: `${BASE_PATH_API}/ownershipaccounts`
    },
    updateOwnershipAccount: {
        method: 'POST',
        url: `${BASE_PATH_API}/ownershipaccounts/:id`
    },
    getOwnersForOwnershipAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownershipAccounts/:id/owners`,
        isArray: true
    },
    getOwnersForOwnershipAccountCached: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownershipAccounts/:id/owners`,
        isArray: true,
        cache: true,
    },
    getOwnershipAccountOwnersV2: { // TODO: rename to getOwnersForOwnershipAccountV2, to match the original
        method: 'GET',
        url: `${BASE_PATH_API}/v2/ownershipAccounts/:id/owners`
    },
    getOwnershipAccountUsers: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownershipAccounts/:id/users`,
        isArray: true
    },
    getBalanceSummary: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownershipAccounts/:id/balanceSummary`
    },
    getTenantsForOwnershipAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownershipAccounts/:id/tenants`,
        isArray: true
    },
    updatePurchaseDate: {
        method: 'PUT',
        url: `${BASE_PATH_API}/ownershipaccounts/:id/purchaseDate`
    },
    getOwnershipAccountsOutstandingBalances: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownershipaccounts/outstandingBalances`,
        isArray: true
    },
    submitPaymentsInBulk: {
        method: 'POST',
        url: `${BASE_PATH_API}/unitAgreements/bulk/payments?type=${BUILDING_TYPE.HOA}`,
        isArray: true
    },
    updateOwnershipAccountComment: {
        method: 'PUT',
        url: `${BASE_PATH_API}/ownershipAccounts/:id/comment`
    },
    getOwnershipAccounts: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownershipAccounts`,
        params: {
            '$count': true
        }
    },
    getOwnershipAccountsForPayment: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownershipAccounts/list`,
    },
    updateOwnershipAccountDelinquencyStatus: {
        method: 'PUT',
        url: `${BASE_PATH_API}/ownershipAccounts/delinquency/:id`
    },
    getOwnershipAccountInfoForLedger: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownershipAccounts/:id/ledgerInfo`
    },
    getOwnershipAccountBalances: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownershipAccounts/:id/balances`
    },
    getOwnershipAccountBalanceSummaryV2: {
        method: 'GET',
        url: `${BASE_PATH_API}/v2/ownershipAccounts/:id/balanceSummary`
    },
    getOwnershipAccountDeposits: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownershipAccounts/:id/deposits`,
        params: {
            '$count': true
        }
    },
    getOwnershipAccountIsResidentStatementEmailAllowed: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownershipAccounts/:id/isResidentStatementEmailAllowed`
    },
    getOwnershipAccountLedgerByAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownershipAccounts/:id/ledgerByAccount`,
        params: {
            '$count': true
        }
    },
    getOwnershipAccountLedgerByDate: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownershipAccounts/:id/ledgerByDate`,
        params: {
            '$count': true
        }
    },
    getOwnershipAccountRecurringTransactions: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownershipAccounts/:id/recurringTransactions`,
        params: {
            '$count': true
        }
    },
    getOwnershipAccountLedgerPdfExport: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownershipAccounts/:id/ledger/exportPdf`
    },
    sendResidentStatement: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownershipAccounts/:id/sendResidentStatement`
    },
    deleteOwnershipAccountLedgerTransaction: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/ownershipAccounts/:id/ledger/:journalId`
    },
    getOwnershipAccountOwner: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownershipAccounts/:id/owners/:ownerId`
    },
    getActiveOwnershipAccountsByUnit: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownershipAccounts/active?unitId=:unitId`
    },
    getUnpaidLateFees: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownershipAccounts/:ownershipAccountId/unpaidLateFees`
    },
};

export function OwnershipAccountsApi(
    $httpParamSerializer
) {
    const service = createActions(actions);

    service.getOwnershipAccountsExportUrl = function getLeasesExportUrl(params) {
        return `${BASE_PATH_API}/ownershipAccounts/export?${$httpParamSerializer(params)}`;
    };

    return service;
}
OwnershipAccountsApi.$inject = [
    '$httpParamSerializer'
];
